<template>
  <div class="warp" style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
    <div style="margin-bottom: 10px">
      <el-form
        ref="formSearch" :model="searchForm" label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('uploadFile.statisticsDate')">
              <!-- 统计日期 -->
              <el-date-picker
                v-model="dateTime"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="searchForm.params.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 州 -->
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.state')">
              <el-select
                v-model="searchForm.params.states"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--客户-->
            <el-form-item :label="$t('newOrder.CustomerName')" name="customerIds">
              <el-select
                v-model="searchForm.params.customerIds"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @focus="getCustomerPage()"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <div style="margin-top: 10px">
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="getSearch"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="resetForm">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                icon="el-icon-upload2" size="small" type="primary"
                @click="exportToExcel"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        :current-page.sync="searchForm.pageNumber"
        :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 15px 0"
        @current-change="getSearch"
        @size-change="getSearch"
      />
    </div>
  </div>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList';
import { missDetailExport, missDetailPage } from '@/api/newExpressAPI';
import { apiCustomerPage } from '@/api/customer';

export default {
  props: {
    packageDetailDta: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    StateList: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    regionList: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          regionId: '',
          states: [],
          customerIds: [],
          startDate: '',
          endDate: ''
        }
      },
      tableData: [],
      total: 0,
      tableHeaderList: [
        {
          label: this.$t('trajectory.Time'),
          prop: 'operationTime',
          cloWidth: 160
        },
        {
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: 160
        },
        {
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          cloWidth: 160
        },
        { label: this.$t('newOrder.CustomerName'), prop: 'customerName', cloWidth: 160 },
        { label: this.$t('newOrder.waybillStatus'), prop: 'waybillStatusName', cloWidth: 160 },
        {
          label: this.$t('orderCenterCont.typeOperation'),
          prop: 'operationTypeName',
          cloWidth: 160
        },
        { label: this.$t('ClaimsManagement.TrackTime'), prop: 'lastTrackTime', cloWidth: 160 },
        {
          label: this.$t('orderCenterCont.trajectoryContent'),
          prop: 'lastTrackContent',
          cloWidth: 160
        },
        // 操作人员
        { label: this.$t('uploadFile.operator'), prop: 'operationUserName', cloWidth: 160 },
        // 漏扫类型
        {
          label: this.$t('uploadFile.missedScanType'),
          prop: 'missOperationTypeName',
          cloWidth: 160
        },
        // 漏扫网点
        { label: this.$t('uploadFile.missedScanHub'), prop: 'missSiteName', cloWidth: 160 },
        // 漏扫所属州
        { label: this.$t('uploadFile.missedScanState'), prop: 'missState', cloWidth: 160 },
        // 漏扫所属大区
        { label: this.$t('uploadFile.missedScanRegion'), prop: 'missRegionName', cloWidth: 160 }
      ],
      customerList: [],
      dateTime: []
    };
  },
  created() {
    const startDate = this.packageDetailDta.startDate + ' 00:00:00';
    const endDate = this.packageDetailDta.endDate + ' 23:59:59';
    this.dateTime = [startDate, endDate];
    this.getSearch();
  },
  methods: {
    getSearch() {
      if (this.searchForm.params.states.length === 0) {
        this.searchForm.params.states = [this.packageDetailDta.states];
      }
      if (!this.searchForm.params.regionId) {
        this.searchForm.params.regionId = this.packageDetailDta.regionId;
      }
      // this.searchForm.params.customerIds = [this.packageDetailDta.customerIds];
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          regionId: this.searchForm.params.regionId,
          states: this.searchForm.params.states,
          customerIds: this.searchForm.params.customerIds || null,
          startDate: '',
          endDate: ''
        }
      };
      if (this.searchForm.params.customerIds.length === 0) {
        data.params.customerIds = this.packageDetailDta.customerIds;
      }
      if (this.dateTime && this.dateTime.length > 0) {
        data.params.startDate = this.dateTime[0];
        data.params.endDate = this.dateTime[1];
      }
      missDetailPage(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    async exportToExcel() {
      if (this.searchForm.params.states.length === 0) {
        this.searchForm.params.states = [this.packageDetailDta.states];
      }
      if (!this.searchForm.params.regionId) {
        this.searchForm.params.regionId = this.packageDetailDta.regionId;
      }
      // this.searchForm.params.customerIds = [this.packageDetailDta.customerIds];
      const data = {
        regionId: this.searchForm.params.regionId,
        states: this.searchForm.params.states,
        customerIds: this.searchForm.params.customerIds || null,
        startDate: '',
        endDate: ''
      };
      if (this.searchForm.params.customerIds.length === 0) {
        data.customerIds = this.packageDetailDta.customerIds;
      }
      if (this.dateTime && this.dateTime.length > 0) {
        data.startDate = this.dateTime[0];
        data.endDate = this.dateTime[1];
      }
      const res = await missDetailExport(data);
      if (res.code === 200) {
        const toRes = await goResourceTaskList();
        if (toRes) {
          this.$emit('call-parent-method', false);
        }
      }
    },
    resetForm() {
      this.packageDetailDta.customerIds = [];
      this.searchForm.params.customerIds = [];
      this.getSearch();
    },
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
